<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<div class="card text-center">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
        SPRA Status Report
    </div>
    <div class="card-body mat-card">
        <div class="row">
            <div class="col-sm-6">
                <!-- <input type="text" id="txtFromDate" name="txtFromDate" [(ngModel)]="this.FromDate"
                            class="form-control"> -->
                            <div class="form-group row text-left">
                                <label for="lblFromDate" class="col-sm-4 col-form-label">From Date 
                                  <span class="font-red-flamingo">*</span> </label>
                                <div class="col-sm-8">
                                  <div class="input-group">
                                    <input class="form-control " (click)="d.toggle()"  placeholder="dd/mm/yyyy" name="txtFromDate" [(ngModel)]="this.FromDate"
                                      ngbDatepicker #d="ngbDatepicker">
                                    <div class="input-group-append">
                                      <button class="btn btn-light fa fa-calendar" (click)="d.toggle()" type="button"></button>
                                    </div>
                                  </div>
                      
                      
                                  <!-- <input type="text" id="txtContactPoDate" name="txtContactPoDate" class="form-control text-uppercase"> -->
                                </div>
                              </div>
               

            </div>
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblToDate" class="col-sm-4 col-form-label">To Date
                        <span class="font-red-flamingo text-left">*</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" (click)="t.toggle()"  placeholder="dd/mm/yyyy" name="txtToDate" [(ngModel)]="this.ToDate"
                              ngbDatepicker #t="ngbDatepicker">
                            <div class="input-group-append">
                              <button class="btn btn-light fa fa-calendar" (click)="t.toggle()" type="button"></button>
                            </div>
                          </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblOffice" class="col-sm-4 col-form-label">Office <span
                            class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                      
                        <select id="ddlOffice" (change)="changeOffice()"  name="ddlOffice" [(ngModel)]="officeId" class="form-control">
                            <option *ngFor="let ol of OfficeList" value={{ol.officeId}}>{{ol.officeDesc}} </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row text-left">
                  <label for="lblStatus" class="col-sm-4 col-form-label">Product Segment</label>
                  <div class="col-sm-8" >
                    <ng-select bindLabel="name" [(ngModel)]="selectedProdSegment" [multiple]="true"  placeholder="Select Product Segment"  name="sctProductSegment" 
                    [searchable]="true"  
                     >
                    <ng-option [value]="p.prodSegmentId"  *ngFor="let p of ProductCategoryList">                                
                        {{p?.prodSegmentDesc}}
                    </ng-option>
                </ng-select>
                  </div>
              </div>
             
          </div>
           
           
        </div>
       
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group row text-left">
                <label for="lblIntiatedBy" class="col-sm-4 col-form-label">Entered By</label>
                <div class="col-sm-8">
                    <!-- {{this.EnteredBy}} -->
                    <!-- <input type="text" id="txtFromDate" name="txtFromDate" [(ngModel)]="this.EnteredBy"
                        class="form-control"> -->
                    <select id="ddlEmployee" name="ddlEmployee" [(ngModel)]="this.EnteredBy" class="form-control">
                        <option *ngFor="let ol of EmployeeList" value={{ol.employeeid}}>{{ol.employeename}}
                        </option>
                    </select>
                </div>
            </div>

        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
              <label for="lblStatus" class="col-sm-4 col-form-label">Product Group</label>
              <div class="col-sm-8" >
                <ng-select bindLabel="name" [multiple]="true" [(ngModel)]="selectedProdGroup"  placeholder="Select Product Group"  name="sctProductSegment" 
                [searchable]="true"  
                 >
                <ng-option [value]="pg.productGroupId"  *ngFor="let pg of ProductGroupList">                                
                    {{pg?.productGroupDesc}}
                </ng-option>
            </ng-select>
              </div>
          </div>
         
      </div>
      
       

        </div>


        

        <div class="row">

          <div class="col-sm-6">
            <div class="form-group row text-left">
                <label for="lblCustomerName" class="col-sm-4 col-form-label">Company Name</label>
                <div class="col-sm-8">
                    <input type="text" id="txtCustomerName" name="txtCustomerName" [(ngModel)]="this.customerName"
                        class="form-control">
                </div>
            </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
              <label for="lblStatus" class="col-sm-4 col-form-label">SaleType</label>
              <div class="col-sm-8" >
                <ng-select bindLabel="name" [(ngModel)]="selectedSaleType" [multiple]="true"  placeholder="Select SaleType "  name="sctSaleType"
              [searchable]="true"  
               >
              <ng-option  *ngFor="let s of SaleTypeList" [value]="s.SaleType">                                
                  {{s?.SaleType}}
              </ng-option>
          </ng-select>
              </div>
          </div>
         
      </div>
          
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group row text-left">
                <label for="lblCustomerName" class="col-sm-4 col-form-label">Report Type</label>
                <div class="col-sm-8">
                    <mat-radio-group  [(ngModel)]="this.rptType" >
                        <mat-radio-button value="E" class="pr-2">Excel</mat-radio-button>
                        <mat-radio-button value="V">View</mat-radio-button>
                      </mat-radio-group>
                </div>
            </div>
           
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
              <label for="lblStatus" class="col-sm-4 col-form-label">Status <span class="font-red-flamingo text-left">*</span></label>
              <div class="col-sm-8" >
              <mat-checkbox color="primary"  *ngFor="let item of checkboxesDataList" [(ngModel)]="item.isChecked" (change)="changeSelection()"><span>{{item.label}}
              </span></mat-checkbox>
              </div>
          </div>
         
      </div>
         
        </div>
        <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-6">
                <button type="button" [disabled]="Enable" class="btn btn-primary" (click)="OnSubmit()">Submit</button>

            </div>
            <div class="col-sm-4"></div>    
        </div>
    </div>

</div>

<div class="card text-center" *ngIf="dataSource.data.length>0" >
    <div class="card-header bg-primary text-left text-white font-weight-bold">
     Spra Status View
    </div>
    <div class="card-body mat-card">
      <div class="row">

        <div class="col-sm-12">
          <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control" (keyup)="doFilter($event)" placeholder="Filter">
          </div>
        </div>




        <div class="col-sm-12">
          
          <mat-table #table [dataSource]="dataSource" matSort *ngIf="dataSource.data.length>0">

             <!-- Position Column -->
             <ng-container matColumnDef="RequestNo">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Request No </mat-header-cell>
              <mat-cell *matCellDef="let element" target="_Blank"  class="btn-link text-primary" (click)="onRequestClick(element)" > {{element.requestNo}}  </mat-cell>              
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="RequestDate">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Request Date </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.initiatedOn}} </mat-cell>
              
            </ng-container>

            <ng-container matColumnDef="Office">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Office </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.office}} </mat-cell>
              
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="EnteredBy">
              <mat-header-cell mat-sort-header *matHeaderCellDef>Entered By </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.enteredBy}} </mat-cell>
            </ng-container>

           

             <!-- Position Column -->
             <ng-container matColumnDef="Salecode">
                <mat-header-cell mat-sort-header *matHeaderCellDef> SaleCode </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.salecode}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
               <ng-container matColumnDef="CustomerName">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Customer </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.customerName}} </mat-cell>
              </ng-container>
             <ng-container matColumnDef="SaleType">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Type </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.saleType}} </mat-cell>
              </ng-container>
               <!-- Position Column -->
             <ng-container matColumnDef="SPRA">
                <mat-header-cell mat-sort-header *matHeaderCellDef>SPRA Type </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.spra}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ProductSegmentDesc">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Product Segment </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.productSegmentDesc }} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Status">
                <mat-header-cell mat-sort-header *matHeaderCellDef>Status </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.status }} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="PendingWith">
                <mat-header-cell mat-sort-header *matHeaderCellDef>PendingWith </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.pendingWith }} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LastValidateDate">
                <mat-header-cell mat-sort-header *matHeaderCellDef> Last Validate Date </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.lastValidateDate }} </mat-cell>
              </ng-container>
            <mat-header-row *matHeaderRowDef="SPRAStatusViewHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: SPRAStatusViewHeader;"></mat-row>
          </mat-table>
        </div>
        <div *ngIf="dataSource.data.length == 0" class="col-sm-12">No Data Exists</div>
        <div class="col-sm-12">
          <div class="col-sm-6 float-right text-right">
            <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>